import { useQueryClient } from 'react-query';

export const useQueryClientHook = () => {
  const queryClient = useQueryClient();
  return [queryClient];
};
